import React, { FC, ChangeEvent } from 'react'
import { Controller } from 'react-hook-form'
import isUndefined from 'lodash/isUndefined'
import { CurrencyInput } from 'transfix-ui/components/CurrencyInput'
import Grid from 'transfix-ui/core/Grid'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useCreateLoadFormContext } from 'apps/fleet-planner/context'
import { TextInput } from 'components/atoms'
import { ControlledCustomer } from '../form-components/ControlledCustomer'
import { ControlledEquipment } from '../form-components/ControlledEquipment'
import { SectionHeaderText } from './SectionHeaderText'

/**
 * Load details section in Create Load flow
 */
export const SectionLoadDetails: FC = () => {
  const { control, errors } = useCreateLoadFormContext()
  const { isMobile } = useBreakpointContext()

  return (
    <Grid id='section-load-details' container spacing={3}>
      <Grid item xs={12} md={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SectionHeaderText>Load Details</SectionHeaderText>
          </Grid>
          <Grid item xs={12}>
            <ControlledCustomer
              name='customer'
              control={control}
              CustomerProps={{
                large: isMobile,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name='rate'
              render={({ onChange, value }) => {
                const changeHandler = ({ value: rate }: { value: string }) => {
                  onChange(rate)
                }

                const formattedValue =
                  !isUndefined(value) && value !== '' ? Number(value) : undefined

                return (
                  <CurrencyInput
                    placeholder='$'
                    label='Rate'
                    value={formattedValue}
                    onChange={changeHandler}
                    dataTest='load-details-rate'
                    large={isMobile}
                    validationMessage={errors?.rate?.message}
                    invalid={!!errors?.rate?.message}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name='miles'
              render={({ onChange, value }) => {
                const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
                  onChange(e.target.value)
                }
                return (
                  <TextInput
                    placeholder='0000'
                    label='Miles'
                    type='number'
                    value={value || ''}
                    onChange={changeHandler}
                    dataTest='load-details-miles'
                    large={isMobile}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <ControlledEquipment
              name='equipment'
              control={control}
              defaultValue={{}}
              EquipmentProps={{
                large: isMobile,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
